import gql from 'graphql-tag';

export const GetCollabPermissionTokenQuery = gql`
	query getCollabToken($contentId: ID!, $draftShareId: String) {
		collabToken(id: $contentId, draftShareId: $draftShareId) {
			token
		}
	}
`;
